"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "m19.571 5.733 1.763-1.763a.923.923 0 1 0-1.301-1.31L17.77 4.92a16.614 16.614 0 0 0-5.769-.996C5.384 3.924.003 7.542.003 12c0 2.52 1.726 4.781 4.43 6.258L2.672 20.03a.923.923 0 0 0 1.001 1.506.924.924 0 0 0 .3-.204l2.262-2.252a16.796 16.796 0 0 0 5.768.997c6.618 0 12-3.628 12-8.077 0-2.529-1.726-4.78-4.43-6.267ZM1.85 12c0-3.378 4.615-6.23 10.153-6.23a15 15 0 0 1 4.31.618l-1.624 1.616a4.818 4.818 0 0 0-6.682 6.682L5.81 16.892C3.42 15.738 1.85 13.957 1.85 12Zm13.126 0a2.954 2.954 0 0 1-4.31 2.64l3.977-3.941c.21.402.323.848.333 1.301ZM9.03 12a2.972 2.972 0 0 1 2.972-2.972c.467 0 .926.115 1.339.332l-3.978 3.98A2.99 2.99 0 0 1 9.03 12Zm2.972 6.23c-1.459 0-2.91-.208-4.31-.618l1.615-1.615A4.818 4.818 0 0 0 16 9.305l2.197-2.197c2.39 1.154 3.96 2.926 3.96 4.892 0 3.378-4.615 6.23-10.154 6.23Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};